export default "/assets/images/pet-dander-video-thumbnail.2334dfadf3ef1403.jpg";